import { render } from "./Icone.vue?vue&type=template&id=3e2c04e2"
import script from "./Icone.vue?vue&type=script&lang=js"
export * from "./Icone.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__